var map = {
	"./01-austen.jpg": 81,
	"./01-leaving-ny.jpg": 82,
	"./02-ft-worth-texas.jpg": 83,
	"./02-lambda-feedback.jpg": 84,
	"./03-california.jpg": 85,
	"./03-covid.jpg": 86,
	"./04-mom-project.jpg": 87,
	"./LambdaSchool.jpg": 88,
	"./VishSingh.jpg": 89,
	"./journey.jpg": 90,
	"./logo.png": 44,
	"./roadtrip.jpg": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29;